




import { Vue, Component } from 'vue-property-decorator';
import { commerceApi } from '@/api';
import { cosSectionCode } from '@/const/cosSection';
import { namespace, State } from 'vuex-class';
import { Mall } from 'ncp-api-supporter';
import type { Admin } from '@/types';

const adminModule = namespace('admin');

@Component({
  computed: {
    cosSectionCode() {
      return cosSectionCode;
    },
  },
})
export default class CosMainBanner extends Vue {
  @adminModule.Getter('admin') private admin!: Admin;
  @State('malls', { namespace: 'mall' })
  public malls!: Mall[];

  private bannerHtml = '';

  private async fetchCosSections(): Promise<void> {
    const shopNos = this.malls.map(({ shopNo }) => shopNo).filter(Boolean);
    const { data } = await commerceApi.getCosSectionsSectionCode({
      pathParams: { sectionCode: cosSectionCode.MAIN_BANNER },
      params: { shopNos },
    });

    if (data.sectionType !== 'BANNER') {
      return;
    }

    /** @description 슬라이드 배너는 아직이라, 우선 첫 요소만 추출 */
    const firstPost = data.posts?.at(0).postBodyText ?? '';
    this.bannerHtml = firstPost;
  }

  mounted() {
    if (this.admin.plan !== 'STANDARD') {
      this.fetchCosSections();
    }
  }
}
